import React, { useEffect, useState } from 'react';
import { PDFViewer, Document, Page, View, Text, Image } from '@react-pdf/renderer';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../config';


const PdfReport = ({ studentData, currentDateTime }) => (
  <Document>
    <Page size="A4" orientation="landscape" style={{ padding: 15, fontSize: 10, fontFamily: 'Helvetica' }}>
      {/* Header Section */}
      <View fixed style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        <Image src="../assets/images/MBOSE.png" style={{ width: 40, height: 40, marginRight: 10 }} />
        <View style={{ flex: 1, textAlign: 'center' }}>
          <Text style={{ fontSize: 12, fontWeight: 'bold' }}>Meghalaya Board Of School Education ( SSLC )</Text>
          <Text style={{ marginTop: 4, fontSize: 10, fontWeight: 'bold' }}>
            List of Examinees Supplementary Examination, Online Applications for 2026
          </Text>
        </View>
      </View>

      {/* Centre Info Section */}
      <View fixed style={{ flexDirection: 'row', justifyContent: 'space-between', paddingBottom: 10, marginBottom: 10 }}>
        <Text style={{ fontSize: 10 }}>
          <Text style={{ fontWeight: 'bold' }}>Centre Code: </Text>
          <Text style={{ textDecoration: 'underline' }}>{localStorage.getItem('CentCode')}</Text>
        </Text>
        <Text style={{ fontSize: 10 }}>
          <Text style={{ fontWeight: 'bold' }}>Centre Name: </Text>
          <Text style={{ textDecoration: 'underline' }}>{localStorage.getItem('schoolName')}</Text>
        </Text>
        <Text style={{ fontSize: 10 }}>
          <Text style={{ fontWeight: 'bold' }}>Exam Type : </Text>
          <Text style={{ textDecoration: 'underline' }}>Supplementary</Text>
        </Text>
      </View>

      {/* Table Header */}
      <View style={{ marginTop: 10, marginHorizontal: 20, fontSize: 7 }}>
        <View style={{ flexDirection: 'row', backgroundColor: '#f0f0f0' }}>
          {[
            'Sl No.',
            'Roll Number',
            'Reg. No',
            'Name of Applicant',
            "Father's Name",
            "Mother's Name",
            'Subject 1',
            'Subject 2',
            'Subject 3',
            'Subject 4',
            'Subject 5',
            'Subject 6',
          ].map((header, index) => (
            <Text
              key={index}
              style={{
                flex: 1,
                fontWeight: 'bold',
                textAlign: 'center',
                fontSize: 7,
                border: '1px solid black',
                padding: 2,
              }}
            >
              {header}
            </Text>
          ))}
        </View>

        {/* Table Data */}
        {studentData.map((student, index) => (
          <View key={index} style={{ flexDirection: 'row' }} break={index % 20 === 0 && index !== 0}>
            <Text style={cellStyle}>{index + 1}</Text>
            <Text style={cellStyle}>{student.ROLL_NO || '-'}</Text>
            <Text style={cellStyle}>{student.REGISTRATION_NUMBER || '-'}</Text>
            <Text style={cellStyle}>{student.CAND_NAME || '-'}</Text>
            <Text style={cellStyle}>{student.FATHERS_NAME || '-'}</Text>
            <Text style={cellStyle}>{student.MOTHERS_NAME || '-'}</Text>
            <Text style={cellStyle}>{student.SUBJECT_1 || '-'}</Text>
            <Text style={cellStyle}>{student.SUBJECT_2 || '-'}</Text>
            <Text style={cellStyle}>{student.SUBJECT_3 || '-'}</Text>
            <Text style={cellStyle}>{student.SUBJECT_4 || '-'}</Text>
            <Text style={cellStyle}>{student.SUBJECT_5 || '-'}</Text>
            <Text style={cellStyle}>{student.SUBJECT_6 || '-'}</Text>
          </View>
        ))}
      </View>

      <Text style={{ fontSize: 10, fontWeight: 'bold', marginTop: 10, marginLeft: 20 }}>
        Generated on: {currentDateTime}
      </Text>
    </Page>
  </Document>
);

const SupplimentaryChecklist = ({ supplementaryCandidateIds }) => {
  const [studentData, setStudentData] = useState([]);
  const [currentDateTime, setCurrentDateTime] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const now = new Date();
    const formattedDateTime = `${String(now.getDate()).padStart(2, '0')}/${String(now.getMonth() + 1).padStart(2, '0')}/${now.getFullYear()} ${now.toLocaleTimeString()}`;
    setCurrentDateTime(formattedDateTime);


    const fetchData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');

        // Parse candidate IDs correctly
        const storedSupplementaryIds = localStorage.getItem('supplementaryIds') || '[]';

        const response = await axios.post(
          `${config.API_BASE_URL}/Auth/GetCheckListData`,
          {
            candidatE_ID: storedSupplementaryIds, // Use parsed array
            centeR_CODE: localStorage.getItem('CentCode'),
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (response.status === 200 && response.data) {
          setStudentData(response.data.data.data_list || []);
          console.log('Fetched student data:', response.data.data.data_list);
        } else {
          Swal.fire('Error', 'Error fetching checklist data. Please try again.', 'error');
        }
      } catch (error) {
        console.error('Error generating checklist:', error);
        Swal.fire('Error', 'An error occurred while generating the checklist.', 'error');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [supplementaryCandidateIds]);

  return (
    <>
      {loading ? (
        <div>Loading data...</div>
      ) : studentData.length > 0 ? (
        <PDFViewer style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
          <PdfReport studentData={studentData} currentDateTime={currentDateTime} />
        </PDFViewer>
      ) : (
        <div>No data available</div>
      )}
    </>
  );
};

// Style for table cells
const cellStyle = {
  flex: 1,
  textAlign: 'center',
  fontSize: 7,
  border: '1px solid black',
  padding: 2,
};

export default SupplimentaryChecklist;
